import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { getDateFormat } from "@utils/datePickerUtils";
import {
  DivBackgroundFullOpacity,
  DivBackgroundLowOpacity,
} from "@utils/extra-style";

const ValidityDate = (props) => {
  const { t, data } = props;
  return (
    <>
      {data.isActive == 0 && (
        <DivBackgroundLowOpacity>
          {data.validityStartDate === null &&
            data.validityEndDate == null &&
            t("NONE")}
          {data.validityStartDate !== null &&
            data.validityEndDate == null &&
            getDateFormat(data.validityStartDate, "YYYY-MM-DD") +
              " - " +
              t("NONE")}
          {data.validityEndDate !== null &&
            data.validityStartDate === null &&
            t("NONE") +
              " - " +
              getDateFormat(data.validityEndDate, "YYYY-MM-DD")}

          {data.validityStartDate !== null &&
            data.validityEndDate !== null &&
            getDateFormat(data.validityStartDate, "YYYY-MM-DD") +
              " - " +
              getDateFormat(data.validityEndDate, "YYYY-MM-DD")}
        </DivBackgroundLowOpacity>
      )}
      {data.isActive == 1 && (
        <DivBackgroundFullOpacity>
          {data.validityStartDate === null &&
            data.validityEndDate == null &&
            t("NONE")}
          {data.validityStartDate !== null &&
            data.validityEndDate == null &&
            getDateFormat(data.validityStartDate, "YYYY-MM-DD") +
              " - " +
              t("NONE")}
          {data.validityEndDate !== null &&
            data.validityStartDate === null &&
            t("NONE") +
              " - " +
              getDateFormat(data.validityEndDate, "YYYY-MM-DD")}

          {data.validityStartDate !== null &&
            data.validityEndDate !== null &&
            getDateFormat(data.validityStartDate, "YYYY-MM-DD") +
              " - " +
              getDateFormat(data.validityEndDate, "YYYY-MM-DD")}
        </DivBackgroundFullOpacity>
      )}
    </>
  );
};

ValidityDate.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ValidityDate);
